import styled from 'styled-components'
import React from 'react'
import {FormatProduct} from '../../../types/rest'
import {useSelector} from 'react-redux'
import {getLanguage, getTranslation} from '@store/selectors'
import conf from '@configuration'
import useProductNavigate from '../../../hooks/useProductNavigate'
import {Thumbnail} from '@components/common'

interface Props {
    data: FormatProduct
    bannerColor?: string
}

/** Card da inserire nello slider per la presentazione dei format */
const RecommendedFormatCard: React.FC<Props> = ({ data }) => {
    const language = useSelector(getLanguage)
    const navigateProd = useProductNavigate()
    const translation = useSelector(getTranslation)

    return (
        <Container onClick={() => navigateProd(data.product)}>
            <Thumbnail style={{ aspectRatio: '16/10', marginBottom: 'var(--max-distance-slider)' }} src={`${conf.baseUrl}${data?.product.thumbnail}`} />
            <InfoBox>
                {((data?.product.type as any).label === 'course' || data.product.type === 'course') && <Badge contentType={(data?.product.type as any)?.label || data.product.type}>{translation.common.buttons.course}</Badge> }
                {((data?.product.type as any).label === 'masterclass' || data.product.type === 'course') && <Badge contentType={(data?.product.type as any)?.label || data.product.type}>{translation.entities.AuthorContent}</Badge> }
                {data?.product.translations && (
                  <div>
                    {(data as any)?.product.translations[`${language}`]?.surtitle  && <Surtitle>
                      {`${(data as any)?.product.translations[`${language}`]?.surtitle || ''}`}
                    </Surtitle>}
                      <p
                        style={{
                            maxWidth: '80vw',
                            fontSize: '25px',
                            fontWeight: '600',
                            lineHeight: '30px',
                            margin: 0,
                            marginBottom: 'var(--min-distance-slider)'
                        }}>
                          {`${(data as any)?.product.translations[`${language}`]?.title}  `}
                      </p>

                      {(data as any)?.product.translations[`${language}`]?.subtitle && <Subtitle >
                          {`${(data as any)?.product.translations[`${language}`]?.subtitle}  `}
                      </Subtitle>}

                  </div>
                )}
            </InfoBox>
        </Container>
    )
}

export default RecommendedFormatCard

//region Style

const Container = styled.div`
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  width: var(--card-width-responsive);
  @media (max-width: 1024px){
    width: calc(var(--card-width-responsive) - 50px);
  }
  max-width: 427px;
  min-width: 15rem;
  height: fit-content;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`

/*const Title = styled.p<{isMobile?: boolean}>`
  font-size: var(--list-title-fs-mobile);
  font-weight: 600;
  margin: 5px 0;
  word-break: break-word;
`*/

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

`

const Badge = styled.div<{contentType?: string}>`
  width: fit-content;
  background-color: ${({contentType}) =>  contentType === 'course' ? '#fff' : 'var(--primary)'};
  color: ${({contentType}) =>  contentType === 'course' ? 'var(--primary)' : '#fff'};
  font-weight: ${({contentType}) =>  contentType === 'course' ? '600' : '500'};
  display: inline-block;
  padding: 6px 12px;
  line-height: 1;
  text-align:center;
  margin-bottom: var(--max-distance-slider);
  font-size:var(--badge-font-size);
`

const Surtitle = styled.span`
  font-size: var(--surtitle-fs);
  color: #fff;
  margin-bottom: var(--min-distance-slider);
  display: block;
`


const Subtitle = styled.span`
  display: block;
  font-size: var(--subtitle-fs); 
  color: #fff;
`

//endregion
